import React, { useState, useContext } from "react";
import { useTranslation } from 'react-i18next';
import axios from "../../axiosConfig";
import { TrainerContext } from "../../context/TrainerContext";
import { useToast } from "../commons/toast/ToastContext";
import "../../styles/ExerciseModal.css";
import { AiOutlineClose } from "react-icons/ai";

const AddExerciseModal = ({ onClose, onSuccess }) => {
    const { t } = useTranslation(['exercises', 'common']);
    const { trainer } = useContext(TrainerContext);
    const toast = useToast();
    const [formData, setFormData] = useState({
        name: "",
        description: "",
        requiredEquipment: "",
        difficultyLevel: "BASIC",
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axios.post(`/api/v1/exercise/school/${trainer.schoolId}/add`, formData, {
                headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}` },
            });

            toast.success(t('exercises:addSuccess', { name: formData.name }), t('common:success'));

            if (onSuccess) {
                onSuccess(response.data);
            }
            onClose();
        } catch (err) {
            toast.error(t('exercises:addError'), t('common:error'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>{t('exercises:addExercise')}</h2>
                    <AiOutlineClose className="close-icon" onClick={onClose} />
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            placeholder={t('exercises:namePlaceholder')}
                        />
                    </div>
                    <div className="form-group">
                        <input
                            type="text"
                            name="requiredEquipment"
                            value={formData.requiredEquipment}
                            onChange={handleChange}
                            placeholder={t('exercises:equipmentPlaceholder')}
                        />
                    </div>
                    <div className="form-group">
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            required
                            placeholder={t('exercises:descriptionPlaceholder')}
                            className="large-textarea"
                        />
                    </div>
                    <div className="form-group">
                        <select
                            name="difficultyLevel"
                            value={formData.difficultyLevel}
                            onChange={handleChange}
                        >
                            <option value="BASIC">{t('exercises:difficulty.basic')}</option>
                            <option value="INTERMEDIATE">{t('exercises:difficulty.intermediate')}</option>
                            <option value="ADVANCED">{t('exercises:difficulty.advanced')}</option>
                        </select>
                    </div>
                    <div className="modal-buttons">
                        <button type="button" className="cancel-btn" onClick={onClose}>
                            {t('common:cancel')}
                        </button>
                        <button
                            type="submit"
                            className={`save-btn ${loading ? "disabled" : ""}`}
                            disabled={loading}
                        >
                            {loading ? t('common:saving') : t('common:save')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddExerciseModal;